const lookupBySlug = (slug: String, list: Array<any>): any => list.find(item => item.slug === slug);

export default lookupBySlug;
